import { Route, Routes, Link, Navigate,  } from "react-router-dom";
import Product from "./pages/Product";
import Home from "./pages/Home";
import ProductList from "./pages/ProductList";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Cart from "./pages/Cart";
import Pay from "./pages/Pay"
import Navbar from "./components/Navbar";
import Success from "./pages/Success";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

// so people using the keyboard for navigation or screen readers will still be able to use this app.import React from "react";
function PrivateRoute({ children, ...rest }) {
  const user = useSelector((state) => state.user.currentUser);
return user?<Navigate to="/" /> : <Outlet/> ;
} 
const App = () => {
  return (
    <div className="App">
      <Routes>
       
          <Route index element={<Home />} />
          <Route path="/cart" element={<Cart />} />
          <Route exact path="/register" element={<PrivateRoute/>} >

          <Route path="/register" element={<Register />} />
          </Route>
          <Route exact path="/login" element={<PrivateRoute/>} >

          <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/product/:id" element={<Product />} />
          <Route path="products/:category" element={<ProductList />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/success" element={<Success />} />
        
      </Routes>
    </div>
  );
};



export default App;
